/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_PROFILE, SEND_SINGLE_PURCHASE_REFERALS, UPDATE_DISCOUNT_STATUS } from "../graphql";
import { VApplication } from "../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { pretty } from "@vlinder-web/utils-react";
import toast from "react-hot-toast";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};


export interface IsendDiscountMethods extends IPluginMethodMap {
  sendDiscountUser(
    args: any
  ): Promise<any>;
}

export class sendDiscountUserService implements IAgentPlugin {
  readonly methods: IsendDiscountMethods;

  constructor() {
    this.methods = {
      sendDiscountUser:
        this.sendDiscountUser.bind(this),
    };
  }

  async sendDiscountUser(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(args);

    try {
      if (client) {
        const _res = await client.query({
          query: GET_MY_PROFILE,
          fetchPolicy: "network-only",
        });
        let committeeId = _res?.data?.getMyProfile?.id;
        console.log(committeeId);
        const res1 = await client.mutate({
          mutation: UPDATE_DISCOUNT_STATUS,
          variables: {
            data: {
              discountId: args?.discount,
              count: 1,
              status: "SentToMasq",
              committeeId: committeeId,
              masqId: args?.userEmail
            }
          },
          fetchPolicy: "no-cache",
        });
        if (res1?.data) {
          toast.success("Discount send successfully")
          return {
            ...res1?.data?.updateDiscountStatus,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
